<template>
  <v-container v-if="!isLoading" fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="7">
        <v-card class="elevation-12">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Подтверждение почтового адреса') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <general-error v-if="!!generalError" />
            <v-alert
                class="text-center"
                :value="!generalError"
                type="success">
              {{ $t('Почтовый адрес успешно подтвержден.') }}
              {{ $t('Для завершения регистрации необходимо войти в систему, заполнить анкетные данные и прикрепить документ, подтверждающий полномочия представителя.') }}
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { ACCOUNT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError
    },
    props: {
      userId: String,
      code: String
    },
    data () {
      return {
        isLoading: false
      }
    },
    created: function () {
      const vm = this
      if (vm.isLoggedIn || !vm.userId || !vm.code) {
        vm.goToRoute(`${vm.urlRootPath}/`)
      }
      vm.confirmEmail()
    },
    methods: {
      ...mapActions(ACCOUNT.NAMESPACE, {
        confirmEmailAction: ACCOUNT.ACTIONS.CONFIRM_EMAIL
      }),
      confirmEmail: async function () {
        const vm = this
        const model = {
          userId: vm.userId,
          code: vm.code.replace(/[;]/g, '/')
        }

        vm.isLoading = true
        try {
          await vm.confirmEmailAction(model)
          vm.isLoading = false
          if (!vm.generalError) {
            setTimeout(function () {
              vm.goToRoute(`${vm.urlRootPath}/login`)
            }, 12000)
          }
        } catch (error) {
          vm.isLoading = false
          vm.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
